let version = require('../../package.json').version

export const environment = {
  production: true,
  envName: 'prod',
  traaqrUser: 'madison@traaqr.com',
  traaqrPassword: 'hummus12',
  gitCommit: 'd769e9f370b411d88403c21b7c3434b2a8024a34',
  buildNumber: '526',
  release: version,
  driveDeveloperKey: 'AIzaSyBFWsx5cy-GlRx8hC8jiOmuGnPbZuforws',
  stripe_pk: 'pk_live_MZFAy1dQqWDafQ8TECZLn84D',
  schedulesBucket: 'veil-schedules-prod'
};
